// extracted by mini-css-extract-plugin
export default {"doubleInputsRow":"ContactInformation_doubleInputsRow__+OoJq","notesInput":"ContactInformation_notesInput__c-5em","inputsWrapper":"ContactInformation_inputsWrapper__+M52T"};